import { render } from "./Auprc.vue?vue&type=template&id=4af76150&scoped=true"
import script from "./Auprc.vue?vue&type=script&lang=js"
export * from "./Auprc.vue?vue&type=script&lang=js"

import "./Auprc.vue?vue&type=style&index=0&id=4af76150&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af76150"]])

export default __exports__